// Extract background decision logic for full branch coverage in tests
export const getLoginCardBackground = (scheme: string) => {
  return scheme === 'dark'
    ? 'var(--mantine-color-surface-elevated-dark-0)'
    : 'var(--mantine-color-surface-elevated-light-0)';
};

export const getButtonShakeAnimation = (animationName: string) => {
  return `@keyframes ${animationName} {
      0% { transform: translateX(0); }
      25% { transform: translateX(-4px); }
      50% { transform: translateX(4px); }
      75% { transform: translateX(-4px); }
      100% { transform: translateX(0); }
    }`;
};
